import Image from 'next/image';
import {
  ComponentsDelivered,
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  List,
} from '../../components';
import styles from './logistic-delivered.module.css';

import phones from '../../public/logistic/phones-min.png';
import phones2 from '../../public/logistic/phones2-min.png';
import phonesGroup from '../../public/logistic/phones-group-min.png';
import laptop from '../../public/logistic/laptop-min.png';
import laptop2 from '../../public/logistic/laptop2-min.png';

import BusinessIcon from '../../public/svg/buisnes.svg';
import WebIcon from '../../public/svg/webpage.svg';
import PaintIcon from '../../public/svg/paint.svg';
import ProcessIcon from '../../public/svg/process.svg';
import MobileIcon from '../../public/svg/mobile.svg';
import TrackIcon from '../../public/logistic/track-circle.svg';
import UserIcon from '../../public/logistic/user-circle.svg';
import ScreenIcon from '../../public/logistic/screen-circle.svg';

export default function LogisticDelivered() {
  return (
    <section className={styles.root}>
      <Container>
        <div className={styles.wrapper}>
          <Htag
            variant={HtagVariant.h2}
            align={HtagAlign.center}
            className={styles.title}
            tag="h2"
          >
            Logistics Solutions We’ve Delivered
          </Htag>
          <div className={styles.block}>
            <div className={styles.block__top}>
              <div className={styles.block__start}>
                <h3 className={styles.block__title}>ESP Freight App</h3>

                <p className={styles.block__text}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum
                </p>

                <ComponentsDelivered
                  className={styles.delivered}
                  title="Components delivered:"
                  data={[
                    {
                      id: 1,
                      text: 'UX/UI design',
                      Icon: PaintIcon,
                    },
                    {
                      id: 2,
                      text: 'Website',
                      Icon: WebIcon,
                    },
                    {
                      id: 3,
                      text: 'Business analysis and prototype',
                      Icon: BusinessIcon,
                    },
                    {
                      id: 4,
                      text: 'Web admin panel',
                      Icon: ProcessIcon,
                    },
                  ]}
                />
              </div>
              <div className={styles.block__end}>
                <Image
                  alt="logistic app preview"
                  width={653}
                  height={637}
                  src={phones}
                  quality={100}
                />
              </div>
            </div>
            <div className={styles.block__bottom}>
              <div className={styles.block__image}>
                <Image
                  alt="logistic admin panel"
                  width={1023}
                  height={584}
                  src={laptop}
                  quality={100}
                />
              </div>
              <div className={styles.block__lists}>
                <List
                  list={[
                    'upload photos',
                    'set parameters',
                    'add a road',
                    'write a description',
                    'set visibility',
                    'choose a type',
                  ]}
                  Icon={TrackIcon}
                  title="Creation of logistics routes"
                />

                <List
                  list={[
                    'create and edit users',
                    'set permissions',
                    'handle incoming messages',
                    'change statuses',
                  ]}
                  Icon={UserIcon}
                  title="User Administration"
                />
              </div>
            </div>
          </div>

          <div className={styles.block}>
            <h3 className={styles.block__title}>GAS App</h3>

            <p className={styles.block__text}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>

            <ComponentsDelivered
              className={styles.delivered}
              appearance="four"
              title="Components delivered:"
              data={[
                {
                  id: 1,
                  Icon: PaintIcon,
                  text: 'UX/UI design',
                },
                {
                  id: 2,
                  Icon: BusinessIcon,
                  text: 'Business analysis and prototype',
                },
                {
                  id: 3,
                  Icon: MobileIcon,
                  text: 'iOS mobile app',
                },
                {
                  id: 4,
                  Icon: ProcessIcon,
                  text: 'Web admin panel',
                },
              ]}
            />

            <div className={styles.phones}>
              <Image
                alt="gas app phones preview"
                width={1051}
                height={648}
                src={phonesGroup}
                quality={100}
              />
            </div>
          </div>

          <div className={styles.block}>
            <div className={styles.block__top}>
              <div className={styles.block__start}>
                <h3 className={styles.block__title}>ESP Freight App</h3>

                <p className={styles.block__text}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum
                </p>

                <ComponentsDelivered
                  className={styles.delivered}
                  title="Components delivered:"
                  data={[
                    {
                      id: 1,
                      text: 'UX/UI design',
                      Icon: PaintIcon,
                    },
                    {
                      id: 2,
                      text: 'iOS mobile app',
                      Icon: MobileIcon,
                    },
                    {
                      id: 3,
                      text: 'Business analysis and prototype',
                      Icon: BusinessIcon,
                    },
                    {
                      id: 4,
                      text: 'Web admin panel',
                      Icon: ProcessIcon,
                    },
                  ]}
                />
              </div>
              <div className={styles.block__end}>
                <Image
                  alt="Mr. Gongi phones preview"
                  width={653}
                  height={637}
                  src={phones2}
                  quality={100}
                />
              </div>
            </div>
            <div className={styles.block__bottom}>
              <div className={styles.block__image}>
                <Image
                  alt="Mr. Gongi site preview"
                  width={1023}
                  height={584}
                  src={laptop2}
                  quality={100}
                />
              </div>
              <div className={styles.block__lists}>
                <List
                  className={styles.last_list}
                  list={[
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ',
                  ]}
                  Icon={ScreenIcon}
                  title="Web adaptation"
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
